<template>
  <section id="header" class="header_main">
    <div class="box_header">
      <a href="tel:89817167552" class="href_tf">+7&nbsp;(981)&nbsp;716-75-52</a>

      <div class="container_nav_header">
        <a href="#catalog" class="href_nav_header">КАТАЛОГ</a>
        <a href="#project" class="href_nav_header">ПРОЕКТЫ</a>
        <a href="" class="href_logo">
          <img src="@/assets/img/logo/logo.png" class="logo_header" />
        </a>
        <a href="#calculator" class="href_nav_header">КАЛЬКУЛЯТОР</a>
        <a href="#reviews" class="href_nav_header">ОТЗЫВЫ</a>
      </div>
    </div>

    <div class="header_burger">
      <button class="button_burger" @click="toggleModal">
        <div
          ref="line_header_burger_1"
          class="line_header_burger line_header_burger_1"
        ></div>
        <div
          ref="line_header_burger_2"
          class="line_header_burger line_header_burger_2"
        ></div>
        <div
          ref="line_header_burger_3"
          class="line_header_burger line_header_burger_3"
        ></div>
      </button>
      <img src="@/assets/img/logo/logo.png" class="logo_header" />
      <div class="button_soc_header">
        <a href="https://t.me/mebeldl_mng" target="_blank" class="round_button">
          <img src="@/assets/img/icon/tg.png" class="tg_img" />
        </a>
        <a target="_blank" href="https://wa.me/79817167552" class="round_button">
          <img src="@/assets/img/icon/phone.png" class="phone_img" />
        </a>
        <a
          href="https://www.avito.ru"
          target="_blank"
          class="round_button"
        >
          <img src="@/assets/img/icon/vk.png" class="vk_img" />
        </a>
      </div>
    </div>
  </section>
  <div ref="section_burger" class="section_burger">
    <div class="burger">
      <div class="burger_nav">
        <a href="#reviews" @click="closeModal" class="href_burger_nav"
          >ОТЗЫВЫ</a
        >
        <a href="#calculator" @click="closeModal" class="href_burger_nav"
          >КАЛЬКУЛЯТОР</a
        >
        <a href="#project" @click="closeModal" class="href_burger_nav"
          >ПРОЕКТЫ</a
        >
        <a href="#catalog" @click="closeModal" class="href_burger_nav"
          >КАТАЛОГ</a
        >
      </div>
      <div class="buger_policy">
        <p class="confidentiality_text">© ООО ”БрендНэйм” 2024</p>
        <a class="confidentiality_text">Политика конфиденциальности</a>
      </div>
      <div class="burger_knit">
        <PhoneUi />
        <a href="tel:89817167552" class="button_phone"
          ><img src="@/assets/img/icon/phone.png" class="icon_phone"
        /></a>
      </div>
      <div class="berger_glow"></div>
    </div>
  </div>
</template>
<script>
import PhoneUi from "./ui/PhoneUi.vue";

export default {
  components: {
    PhoneUi,
  },
  methods: {
    toggleModal() {
      this.$refs.section_burger.classList.toggle("active");
      this.$refs.line_header_burger_1.classList.toggle("active");
      this.$refs.line_header_burger_2.classList.toggle("active");
      this.$refs.line_header_burger_3.classList.toggle("active");

      document.body.classList.toggle("no-scroll");
    },
    closeModal() {
      this.$refs.section_burger.classList.remove("active");
      this.$refs.line_header_burger_1.classList.remove("active");
      this.$refs.line_header_burger_2.classList.remove("active");
      this.$refs.line_header_burger_3.classList.remove("active");

      document.body.classList.remove("no-scroll");
    },
  },
};
</script>
<style scoped>
.header_burger {
  display: none;
}
.logo_header {
  width: 3.5rem;
}
.header_main {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  padding: 1.2rem 8rem;
}
.box_header {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;

  justify-content: center;
}
.box_href {
  position: relative;
}

.href_tf {
  position: absolute;
  left: 0px;
  color: rgb(245, 160, 62);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}
.container_nav_header {
  display: flex;
  align-items: center;
  gap: 4rem;
}
.href_nav_header {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease;
}
.href_nav_header:hover {
  color: rgb(245, 160, 62);
  transition: 0.2s ease;
}
/* .href_logo {
  padding: 0rem 1.5rem 1.6rem 1.5rem;
} */
.burger {
  display: none;
}
@media (max-width: 767px) {
  .header_main {
    padding: 1.7rem 2.4rem 0rem 2.4rem;
    z-index: 3;
  }
  .header_burger {
    display: flex;
    justify-content: space-between;
  }
  .box_header {
    display: none;
  }

  .line_header_burger {
    position: absolute;
    width: 1.71rem;
    height: 0.07rem;
    background: rgb(255, 255, 255);
    left: 0px;
    transition: 0.2s ease;
  }
  .line_header_burger:nth-child(1) {
    background: rgb(245, 160, 62);
    top: 0px;
  }
  .line_header_burger:nth-child(2) {
    top: 0.855rem;
  }
  .line_header_burger:nth-child(3) {
    top: 1.71rem;
  }
  .line_header_burger_1.active {
    display: none;
  }

  .line_header_burger_2.active {
    transform: rotate(45deg) translate(-0.5rem);
    top: 1.2rem;
    left: 0.3rem;
    transition: 0.2s ease;
  }
  .line_header_burger_3.active {
    transform: rotate(-45deg) translate(0.5rem);
    top: 1.2rem;
    left: -0.3rem;
    transition: 0.2s ease;
  }
  .button_burger {
    position: relative;
    width: 1.71rem;
    height: 1.71rem;
  }
  .button_soc_header {
    display: flex;
    flex-direction: column;
    gap: 1.4rem;
  }
  .section_burger {
    display: flex;
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 2;
    background: rgb(51, 47, 47);
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    transition: 0.2s ease;
  }
  .section_burger.active {
    opacity: 1;
    pointer-events: auto;
    transition: 0.2s ease;
  }
  .burger {
    width: 100%;
    height: 100%;
    position: relative;
    background: rgb(51, 47, 47);
    display: flex;
    align-items: flex-end;
    padding: 1rem 2.5rem 3rem 1.7rem;
    flex-direction: column;
    justify-content: flex-end;
    gap: 2.5rem;
  }
  .burger_knit {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .button_phone {
    margin-top: 0.5rem;
    background: linear-gradient(
      90deg,
      rgb(245, 160, 62),
      rgb(207, 117, 14) 102.477%
    );
    width: 2.71rem;
    height: 2.71rem;
    display: flex;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
  }
  .icon_phone {
    width: 1.49rem;
    height: 1.4rem;
  }
  .confidentiality_text {
    color: rgb(255, 255, 255);
    font-family: Roboto;
    font-size: 0.71rem;
    font-weight: 400;
    line-height: 0.86rem;
    letter-spacing: -1%;
    text-align: left;
  }
  .buger_policy {
    width: 100%;
    justify-content: space-between;
    display: flex;
  }
  .burger_nav {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }
  .href_burger_nav {
    color: rgb(255, 255, 255);
    font-family: Roboto;
    font-size: 2.29rem;
    font-weight: 400;
    line-height: 2.71rem;
    letter-spacing: 0%;
    text-align: right;
    transition: 0.2s ease;
  }
  .href_burger_nav:hover {
    color: rgb(245, 160, 62);
    transition: 0.2s ease;
  }
  .berger_glow {
    position: absolute;
    filter: blur(35.71rem);
    background: rgb(245, 160, 62);
    opacity: 0.2;
    width: 60.14rem;
    pointer-events: none;
    height: 60.14rem;
    left: -34.71rem;
    top: 17.57rem;
  }
  .logo_header {
    width: 3.5rem;
    height: auto;
    object-fit: contain;
  }
}
</style>
